import React from 'react';

import Lottie from 'react-lottie';
import anim_page_loader from 'assets/images/animations/page_loader.json';

import "assets/scss/components/loaders/pageLoader.scss";


export function PageLoader() {
    const defaultOptions = {
        loop: true,
        autoplay: true, 
        animationData: anim_page_loader,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    };

    return (
        <div className={"page-loader d-flex justify-content-center align-items-center"}>
            <Lottie options={defaultOptions}
                height={400}
                width={400}
                isClickToPauseDisabled
            />
        </div>
    );
}